<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div [@inOut] class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <input #lvHiddenInput="ngModel" [name]="'lvHidden'" [(ngModel)]="hiddenInputmodel"
           class="lv-hidden-search" [required]="uiArtefakt.PflichtfeldJN">
    <div class="lv-risikosuchfrage"
         [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
      <lv-label-tooltip class="lv-label-tooltip" [label]="uiArtefakt.Text"
                        [labelSymbol]="nestedSymbol"
                        [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                        [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                        [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                        (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
      <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                        [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
      <mat-form-field class="lv-material-form-input" [ngClass]="uiArtefakt.BreiteInPixel"
                      *ngIf="uiArtefakt.RisikosuchfrageComponent === 'AutoComplete' || !uiArtefakt.RisikosuchfrageComponent">
        <div class="lv-progress-bar-search-simple">
          <mat-progress-bar *ngIf="isSearching || showSpinner" mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
        <div class="lv-input-field" [ngClass]="{'lv-error-state': !!getError()}">
          <input type="text"
                 matInput
                 [ngModel]="model"
                 #risikosuchfrageAutoComplete="ngModel"
                 (ngModelChange)="filterOptions($event)"
                 [name]="uiArtefakt.Identifikator"
                 [matAutocomplete]="auto"
                 [errorStateMatcher]="stateMatcherFormInput"
                 (focus)="hasInputFocus = true"
                 (blur)="onBlur()">
        </div>
        <div>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setValue($event.option.value)">
            <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option.WertAnzeige" class="lv-mat-option-multiline">
              <span [innerHTML]="option.WertAnzeige | highlight : risikosuchfrageAutoComplete.value"></span>
              <div *ngFor="let synonym of option.synonyme"
                   [innerHTML]="synonym | highlight : risikosuchfrageAutoComplete.value"
                   class="lv-synonym-option"></div>
            </mat-option>
          </mat-autocomplete>
        </div>
        <mat-error *ngIf="getError() as error" class="lv-control-error"
                   [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}"
                   (click)="onErrorClick()">
          {{error}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="lv-material-form-input" color="accent" *ngIf="uiArtefakt.RisikosuchfrageComponent === 'Dropdown'">
        <div class="lv-input-field" [ngClass]="{'lv-error-state': !!getError()}">
          <mat-select [ngModel]="model" [hideSingleSelectionIndicator]="true"
                      [name]="uiArtefakt.Identifikator"
                      [compareWith]="compareObjects"
                      [errorStateMatcher]="stateMatcherFormInput"
                      #risikosuchfrageDropdown="ngModel"
                      (valueChange)="setValue($event.WertAnzeige)">
            <mat-select-trigger>
              <span>{{uiArtefakt.WertAnzeige}}</span>
            </mat-select-trigger>
            <mat-option *ngFor="let dropdownItem of filteredOptions$ | async" [value]="dropdownItem"
                        class="lv-mat-option-multiline">
              {{dropdownItem.WertAnzeige}}
              <div *ngFor="let synonym of dropdownItem.synonyme" class="lv-synonym-option">
                {{synonym}}
              </div>
            </mat-option>
          </mat-select>
        </div>

        <mat-error class="lv-control-error" *ngIf="getError() as error"
                   [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}"
                   (click)="onErrorClick()">
          {{error}}
        </mat-error>
      </mat-form-field>
      <div *ngIf="!!uiArtefakt?.EigeneEingabeMoeglich" class="lv-eigene-eingabe">
        <div>
          {{'EIGENE_EINGABE_MOEGLICH_TEXT' | translate}}
        </div>
        <div class="lv-eigene-eingabe-button">
          <button mat-raised-button color="accent"
                  (click)="onFreitextUebernehmenClicked(model)">
            {{'EIGENE_EINGABE_MOEGLICH_BUTTON' | translate}}
          </button>
        </div>
      </div>
      <div [@inOut] class="lv-gewaehlte-werte" *ngIf="selectedItems?.length">
        <div class="lv-gewaehlte-werte-ueberschift-container">
          <div class="lv-gewaehlte-werte-ueberschift">
            Ausgewählt:
          </div>
        </div>
        <ng-container *ngFor="let item of selectedItems, trackBy: trackByFn">
          <div class="lv-gewaehlte-werte-item">
            <div>{{item.WertAnzeige}}</div>
            <div class="lv-flex-row-icons">
              <div class="lv-icon-padding" *ngIf="hasDialog(item) | async">
                <mat-icon class="lv-dialog-icon-pencil" [svgIcon]="'Pencil'"
                          (click)="onEditItemClicked(item)"></mat-icon>
              </div>
              <mat-icon class="lv-dialog-icon-trash" [svgIcon]="'Trash'"
                        (click)="onDeleteItemClicked(item)"></mat-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</form>
